import ActionTypes, {PRODUCTS_MAP} from "./constants";
import { ContainerState, ContainerActions } from "./types";

import ApplicationActionTypes from "../application/constants";
import {
  AllInterferometricStacksType,
  InterferometricStackSearchResultsType,
  SearchResultsType
} from "../../types/product";
import {isInterferometricStackSearchResults} from "../../helpers/searchResultsHelper";
import {getInterferometricStackIdentifierFrom} from "../../helpers/interferometricStackHelper";

export const resetSearchState = {
  searchResults: null,
  isSearchingResults: false,
  isListViewActive: true,
  isFramingViewActive: true,
  selectedProducts: [],
  isInterferometricStackSearch: false,
  error: ""
};

export const initialState = {
  ...resetSearchState,
  allProducts: PRODUCTS_MAP,
  allInterferometricStacks: {},
};

const productReducer = (state : ContainerState = initialState, action: ContainerActions): ContainerState => {
  switch (action.type) {
    case ActionTypes.SEARCH_STARTED:
      return { ...state, isSearchingResults: true, error: "" };

    case ActionTypes.SEARCH_RESULTS_SUCCESS:
      return {
        ...state,
        searchResults: action.payload,
        allInterferometricStacks: getAllNewInterferometricStacks(state.allInterferometricStacks, action.payload),
        isSearchingResults: false,
        error: ""
      };

    case ActionTypes.SEARCH_RESULTS_ERROR:
      return { ...state, searchResults: null, isSearchingResults: false, error: action.payload };

    case ActionTypes.TOGGLE_PRODUCTS_VIEW:
      return { ...state, isListViewActive: action.payload };

    case ActionTypes.TOGGLE_FRAMING_VIEW:
      return { ...state, isFramingViewActive: action.payload };

    case ActionTypes.UPDATE_SELECTED_PRODUCTS:
      return { ...state, selectedProducts: action.payload };

    case ActionTypes.REMOVE_ALL_SELECTED_PRODUCTS:
      return { ...state, selectedProducts: [] };

    case ActionTypes.REMOVE_ALL_INTERFEROMETRIC_STACKS:
      return { ...state, allInterferometricStacks: {} };

    case ApplicationActionTypes.RESET_SEARCH:
      return { ...state, ...resetSearchState};

    case ActionTypes.UPDATE_IS_INTERFEROMETRIC_STACK_SEARCH:
      return { ...state, isInterferometricStackSearch: action.payload};

    default:
      return state
  }
};
export default productReducer;


const getAllNewInterferometricStacks = (
  allInterferometricStacks: AllInterferometricStacksType,
  searchResults: SearchResultsType
): AllInterferometricStacksType => {
  return (isInterferometricStackSearchResults(searchResults))
    ? (searchResults as InterferometricStackSearchResultsType).stacks.reduce((acc, stack) => ({
        ...acc,
        [getInterferometricStackIdentifierFrom(stack)]: stack
      }), allInterferometricStacks)
    : allInterferometricStacks;
}
